"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkePromiseQueue = exports.IkePromiseWorker = void 0;
var tslib_1 = require("tslib");
var IkePromiseWorker = /** @class */ (function () {
    function IkePromiseWorker(id) {
        this.failed = 0;
        this.completed = 0;
        this.promise = Promise.resolve();
        this.id = 'worker-' + id;
    }
    IkePromiseWorker.prototype.run = function (task) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.promise];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, task.task()];
                    case 3:
                        result = _a.sent();
                        task.resolve(result);
                        this.completed++;
                        return [3 /*break*/, 5];
                    case 4:
                        e_1 = _a.sent();
                        task.reject(e_1);
                        this.failed++;
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    IkePromiseWorker.prototype.stats = function () {
        return {
            id: this.id,
            completed: this.completed,
            failed: this.failed
        };
    };
    return IkePromiseWorker;
}());
exports.IkePromiseWorker = IkePromiseWorker;
var NOOP = function () { return null; };
/**
 * Queue for promises, will run at most "concurrency" promises at the same time.
 *
 * Example:
 *  const pq = new IkePromiseQueue(2);
 *  pq.add(() => sleep(200))
 *  await pq.join()
 *
 */
var IkePromiseQueue = /** @class */ (function () {
    function IkePromiseQueue(concurrency) {
        /** All workers used by this queue */
        this.workers = [];
        /* Queue of workers ready to be used */
        this.ready = [];
        /** Queue of tasks to be processed */
        this.tasks = [];
        this.concurrency = concurrency;
        for (var i = 0; i < this.concurrency; i++) {
            this.ready[i] = this.workers[i] = new IkePromiseWorker(i);
        }
        this.onIdle = NOOP;
    }
    /**
     *  Join wait for the queue to empty.
     * To make sure all the promises are successful, you must wait for the promises created from .add()
     */
    IkePromiseQueue.prototype.join = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                if (this.isIdle) {
                    return [2 /*return*/, Promise.resolve()];
                }
                return [2 /*return*/, new Promise(function (resolve) {
                        var existingResolve = _this.onIdle;
                        _this.onIdle = function () { existingResolve(); resolve(); };
                    })];
            });
        });
    };
    /**
     * Queue a task in the promise queue
     * Will resolve the returned promise when the task has been executed.
     */
    IkePromiseQueue.prototype.add = function (task) {
        var _this = this;
        var taskObject = { task: task, resolve: null, reject: null, promise: null };
        // tslint:disable:promise-must-complete
        var promise = new Promise(function (resolve, reject) {
            taskObject.resolve = resolve;
            taskObject.reject = reject;
            _this.tasks.push(taskObject);
            if (_this.isAvailable) {
                _this.run();
            }
        });
        taskObject.promise = promise;
        return promise;
    };
    IkePromiseQueue.prototype.run = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var task, worker;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.isIdle) {
                            this.onIdle();
                            this.onIdle = NOOP;
                            return [2 /*return*/, null];
                        }
                        if (this.tasks.length === 0) {
                            return [2 /*return*/, null];
                        }
                        task = this.tasks.shift();
                        if (task == null) {
                            return [2 /*return*/, this.run()];
                        }
                        worker = this.ready.shift();
                        return [4 /*yield*/, worker.run(task)];
                    case 1:
                        _a.sent();
                        this.ready.push(worker);
                        this.run();
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(IkePromiseQueue.prototype, "isAvailable", {
        /**
         * Are there any available workers ready
         */
        get: function () {
            return this.ready.length > 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IkePromiseQueue.prototype, "isIdle", {
        /** Are there any tasks left to do */
        get: function () {
            return this.tasks.length === 0 && this.ready.length === this.concurrency;
        },
        enumerable: false,
        configurable: true
    });
    /** Get the resolution stats of a worker, the number of resolved and  promises */
    IkePromiseQueue.prototype.stats = function () {
        var stats = {};
        for (var _i = 0, _a = this.workers; _i < _a.length; _i++) {
            var worker = _a[_i];
            stats[worker.id] = worker.stats();
        }
        return stats;
    };
    return IkePromiseQueue;
}());
exports.IkePromiseQueue = IkePromiseQueue;
//# sourceMappingURL=promise.queue.js.map